import { render, staticRenderFns } from "./PrivacyPolicyAndTermsOfUseLinks.vue?vue&type=template&id=46e8ed61&"
import script from "./PrivacyPolicyAndTermsOfUseLinks.vue?vue&type=script&lang=js&"
export * from "./PrivacyPolicyAndTermsOfUseLinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./PrivacyPolicyAndTermsOfUseLinks.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports